const context = require.context('./app-types/', true, /\.html$/);

export const templateUrl = appType => {
    let slug = appType.slug;
    if (appType.oidcConfigSupported && slug != 'generic-oauth2' && !slug.endsWith('proxy-sso')) {
        slug = 'generic-oidc';
    }
    const key = `./${slug}/index.html`;
    if (context.keys().includes(key)) {
        return context(key);
    }
};

export const instructionsExist = appType => {
    return !!templateUrl(appType);
};



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/local/paths.js